import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_ADMIN_BID_DATE_TYPE,
  DEFAULT_ADMIN_BID_STATUS_FILTERS,
  DEFAULT_BID_SORT_MODEL
} from "../../util/bid/filterBids";

const initialState = {
  dateTypeFilter: DEFAULT_ADMIN_BID_DATE_TYPE,
  startDateFilter: null,
  endDateFilter: null,
  bidTypeFilters: [],
  statusFilters: DEFAULT_ADMIN_BID_STATUS_FILTERS,
  searchString: "",
  searchStringErrors: "",
  startDateFilterErrors: "",
  endDateFilterErrors: "",
  sortModel: DEFAULT_BID_SORT_MODEL,
};

export const adminBidSlice = createSlice({
  name: "adminBid",
  initialState,
  reducers: {
    updateDateTypeFilter: (state, action) => {
      state.dateTypeFilter = action.payload;
    },
    updateStartDateFilter: (state, action) => {
      state.startDateFilter = action.payload;
    },
    updateEndDateFilter: (state, action) => {
      state.endDateFilter = action.payload;
    },
    updateBidTypeFilters: (state, action) => {
      state.bidTypeFilters = action.payload;
    },
    updateStatusFilters: (state, action) => {
      state.statusFilters = action.payload;
    },
    updateSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    updateSearchStringErrors: (state, action) => {
      state.searchStringErrors = action.payload;
    },
    updateStartDateFilterErrors: (state, action) => {
      state.startDateFilterErrors = action.payload;
    },
    updateEndDateFilterErrors: (state, action) => {
      state.endDateFilterErrors = action.payload;
    },
    updateSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    clearAllAdminBidFilters: () => initialState,
  },
});

export const {
  updateDateTypeFilter,
  updateStartDateFilter,
  updateEndDateFilter,
  updateBidTypeFilters,
  updateStatusFilters,
  updateSearchString,
  updateSearchStringErrors,
  updateStartDateFilterErrors,
  updateEndDateFilterErrors,
  updateSortModel,
  clearAllAdminBidFilters,
} = adminBidSlice.actions;

export const selectAdminBidData = (state) => state.adminBid;

export default adminBidSlice.reducer;
